import address from "../images/address.svg"
import asisstance from "../images/asisstance.svg"
import appointment from "../images/appointment.svg"
import program from "../images/program.svg"

export default [
  {
    icon: address,
    title: "Adresă",
    text: "Strada Rudului, Nr. 262",
  },
  {
    icon: asisstance,
    title: "Asistență",
    text: "0735 222 777, suport@chedratax.ro",
  },
  {
    icon: appointment,
    title: "Programare",
    text: "0735 222 777",
  },
  {
    icon: program,
    title: "Program",
    text: "Luni-Sâmbătă, 8.00 - 18.00",
  },
]
